module.exports = __webpack_public_path__ + "static/zircon-77699cd9430cd8ff0efd36397ceb87f9.svg";